import React, { useState } from 'react';
import { makeStyles, Modal, TextField } from "@material-ui/core";
import CouponBg from "../../assets/images/Apply_coupon_ graphic.svg";
import ClearIcon from "@material-ui/icons/Clear";
import { timeRemainingFromNow } from "examsbook-react-sdk/common";

const useStyles = makeStyles((theme) => ({
    couponModal: {
        zIndex: '9999 !important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    crossIcon: {
        position: 'absolute',
        right: 10,
        top: 10,
        cursor: 'pointer',
        color: '#757575'
    },
    paper: {
        position: 'absolute',
        width: 400,
        backgroundColor: theme.palette.background.paper,
        border: 0,
        boxShadow: theme.shadows[5],
        padding: '16px 30px',
        borderRadius: 8,
        outline: 'none !important',
        '& h2': {
            color: '#000',
            fontSize: 16,
            margin: 0,
            width: '100%',
            textAlign: 'center',
            padding: '20px 0',
        },
        '& > img': {
            width: '100%',
            position: 'absolute',
            left: 0,
            top: 0,
            padding: 10,
        },
        '@media (max-width: 767px)': {
            width: '90%',
            padding: '15px 20px',
        },
    },
    couponList: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    couponCode: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        borderBottom: '1px solid #E9E9E9',
        padding: '14px 0',
        '&:last-child': {
            borderBottom: 0,
        }
    },
    couponText: {
        '& h4': {
            margin: 0,
            fontSize: 13,
            fontWeight: 'bold',
            color: '#4F4F4F',
        },
        '& span': {
            color: '#989898',
            fontSize: 10,
            padding: '3px 0 4px',
            display: 'block',
        },
        '& p': {
            margin: 0,
            fontSize: 10,
            fontWeight: 'bold',
        }
    },
    applyBtn: {
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: 13,
        color: '#008C74',
    },
    disabled: {
        color: '#000000',
    },
    couponTextField: {
        width: '100%',
        position: 'relative',
        marginBottom: 30,
        '& > div': {
            width: '100%',
            '& ::before': {
                display: 'none',
            },
            '& ::after': {
                display: 'none',
            },
            '& input': {
                border: '1px solid #0000001F',
                borderRadius: 6,
                padding: '12px 55px 12px 12px',
                fontSize: 14
            }
        },
        '& > span': {
            cursor: 'pointer',
            color: '#008C74',
            fontSize: 13,
            fontWeight: 600,
            position: 'absolute',
            right: 10,
            top: 13,
        }
    }
}));
const ApplyCouponModel = props => {
    const classes = useStyles();
    const [ couponCode, setCouponCode ] = useState('');
    const { isOpen, closeModel, coupons, applyCouponFn, selectedPlanId } = props;
    const filteredCoupons = coupons && coupons.length ? coupons.filter((coupon) => coupon.plan.find((p) => p._id === selectedPlanId)) : [];
    const modelBody = (
        <div className={classes.paper}>
            <img src={CouponBg} alt=""/>
            <span onClick={closeModel} className={classes.crossIcon}>
                <ClearIcon/>
            </span>
            <h2>Apply Coupon</h2>
            <div className={classes.couponTextField}>
                <TextField
                    value={couponCode}
                    onChange={(event) => {
                        setCouponCode(event.target.value);
                    }}
                    type="text"
                    placeholder="Enter Coupon Code"/>
                <span onClick={() => {
                    if (couponCode && selectedPlanId) {
                        applyCouponFn(couponCode, selectedPlanId);
                    }
                }} className={[ classes.disabled ]}>APPLY</span>
            </div>
            <div className={classes.couponList}>
                {
                    filteredCoupons && filteredCoupons.map((coupon) => {
                        return (
                            <div className={classes.couponCode} key={coupon._id}>
                                <div className={classes.couponText}>
                                    <h4>{coupon.discount}% Off on {' '}
                                        <>
                                            {
                                                coupon.plan && coupon.plan.map((plan) => {
                                                    return plan.name;
                                                }).join(', ')
                                            }
                                        </>
                                        {' '} Pass
                                    </h4>
                                    <span>Offer ends in {timeRemainingFromNow(coupon.validTill)}. Maximum discount {coupon.maxAmount}₹</span>
                                    <p>Coupon Code: {coupon.couponCode}</p>
                                </div>
                                <div className={classes.applyBtn} onClick={() => applyCouponFn(coupon.couponCode, selectedPlanId)}>
                                    APPLY
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
    return (
        <Modal
            open={isOpen}
            onClose={closeModel}
            className={classes.couponModal}>
            {modelBody}
        </Modal>
    );
};

export default ApplyCouponModel;
